import React from 'react';
import { useHistory } from 'react-router';
import { Box, Button, Icon, Modal, Text } from '@nimbus-ds/components';
import { CalendarIcon } from '@nimbus-ds/icons';
import { ROUTES } from 'App/Routes/constants';
import { WeekDay, WithdrawalInterval } from 'commons/types/WithdrawsConfigType';
import { useTranslationWithPrefix } from 'commons/utils';

const AutomaticWithdrawalsModal = ({
  open,
  onDismiss,
  withdrawalInterval,
  dayOfTheWeek,
}: {
  open: boolean;
  onDismiss: () => void;
  withdrawalInterval: WithdrawalInterval;
  dayOfTheWeek?: WeekDay;
}) => {
  const { t } = useTranslationWithPrefix('home.automaticWithdrawalsModal');
  const { t: tWeekDays } = useTranslationWithPrefix('weekDays');

  const history = useHistory();

  const handleClickEditButton = () => {
    history.push(ROUTES.WITHDRAWS_CONFIG);
  };

  return (
    <Modal open={open} onDismiss={onDismiss} maxWidth="420px">
      <Modal.Header title={t('title')} />
      <Modal.Body>
        <Box display="flex" alignItems="center" gap="2" marginY="4">
          <Icon source={<CalendarIcon />} />
          <Text>
            {t(
              withdrawalInterval === 'daily'
                ? 'dailyDescription'
                : 'weeklyDescription',
              {
                dayOfTheWeek: dayOfTheWeek
                  ? tWeekDays(dayOfTheWeek).toLowerCase()
                  : '',
              },
            )}
          </Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClickEditButton} appearance="primary">
          {t('edit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AutomaticWithdrawalsModal;
